<template>
  <video v-if="isVideo"
         ref="dynamic"
         class="dynamic"
         :src="src"
         muted="muted"/>
  <img v-else
       v-lazy="src"
       class="dynamic"
       alt=""/>
</template>

<script>
export default {
  name: "TigerDynamic",

  props: {
    src: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      io: null
    }
  },

  watch: {
    src() {
      this.$nextTick(() => {
        if (this.isVideo) {
          this.observe();
        }
      });
    }
  },

  computed: {
    isVideo() {
      const VIDEO_EX = /.(mp4|mov|wmv|flv)$/g;
      const regExp = new RegExp(VIDEO_EX);
      return regExp.test(this.src);
    }
  },

  methods: {
    handleIOCallback(entries) {
      entries.forEach(({isIntersecting, target}) => {
        if (isIntersecting && target.tagName.indexOf("VIDEO") !== -1) {
          target.play();
        }
      })
    },

    observe() {
      if (this.io == null) {
        this.io = new IntersectionObserver(this.handleIOCallback);
      }
      if (this.$refs.dynamic) {
        this.io.observe(this.$refs.dynamic);
      }
    },

    unobserve() {
      if (this.io && this.$refs.dynamic) {
        this.io.unobserve(this.$refs.dynamic);
        this.io = null;
      }
    }
  },

  mounted() {
    if (this.isVideo) {
      this.observe();
    }
  },

  activated() {
    if (this.isVideo) {
      this.observe();
    }
  },

  deactivated() {
    if (this.isVideo) {
      this.unobserve();
    }
  },

  beforeDestroy() {
    if (this.isVideo) {
      this.unobserve();
    }
  }
}
</script>

<style lang="scss" scoped>
.dynamic {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/TigerDynamic/index.vue